module.exports = __webpack_public_path__ + "static/media/_MIC2583.image.00278c70.png";